export const LOGO_URL = "https://customer-assets-lqy194kg.emergentagent.net/job_splink-preview/artifacts/eizag1wd_logo.png";
export const BRAND_NAME = "Splink.pro";
export const BRAND_TAGLINE = "Shorten. Share. Connect.";
